import React, { useState } from 'react';
import { Text, Div, WarningModalDiv } from './WarningModal.styled';
import Popup from 'src/common/refactoredComponents/popup/Popup';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';	
import CheckCircle from 'src/assets/images/CheckCircle.svg';
import AlertCircleOutline from 'src/assets/images/AlertCircleOutline.svg';
import { vendorCaseIdMsgTemplate, logErrorToConsole } from 'src/utils/util';
import i18n from 'src/i18n.js';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
const t = (key) => i18n.t(key);

const WarningModal = ({
    title,
    titleColor,
    webHeight,
    mbHeight,
    modalContentHeight,
    modalContentWidth,
    onClose,
    message = t('reportUsage.progressBar.SomethingWentWrong'),
    messageColor,
    isSuccess,
    noWarningImg,
    titleWidth,
    titleWebWidth,
    paddingLeft,
    isVendorCaseIdError,
    vendorCaseErrorRedirection,
    statusCode,
    message2,
    mbMarginBottom
}) => {
    const [vendorCaseErrorDetails, setVendorCaseErrorDetails] = useState({});
    useEffectWithErrorLogging(() => {
        if (isVendorCaseIdError && message) {
            const vendorErrorDetails = vendorCaseIdMsgTemplate(
                message,
                statusCode
            );
            setVendorCaseErrorDetails(vendorErrorDetails);
        }
    }, [isVendorCaseIdError, message]);

    return (
        <>
            <Popup
                title={title}
                onClose={onClose}
                img={
                    !noWarningImg &&
                    (isSuccess ? CheckCircle : AlertCircleOutline)
                }
                width={titleWidth}
                webWidth={titleWebWidth}
                colortitle={titleColor}
                id={'reportUsage-warningModal-popup'}
            >
                <WarningModalDiv
                    modalContentHeight={modalContentHeight}
                    modalContentWidth={modalContentWidth}
                >
                    <Text
                        webHeight={webHeight ? webHeight : '130px'}
                        height={mbHeight ? mbHeight : '120px'}
                        paddingLeft={paddingLeft}
                        color={messageColor}
                        mbMarginBottom={mbMarginBottom ? mbMarginBottom : '0'}
                    >
                        {!isVendorCaseIdError
                            ? `${message}`
                            : vendorCaseErrorDetails?.templateMsg &&
                              `${vendorCaseErrorDetails.templateMsg}`}
                        {isVendorCaseIdError &&
                            vendorCaseErrorDetails?.linkedSstRef && (
                                <span
                                    id={`vendor-case-ref-${vendorCaseErrorDetails.linkedSstRef}`}
                                    onClick={() => {
                                        try {
                                        vendorCaseErrorRedirection(
                                            vendorCaseErrorDetails.linkedSstRef,
                                            false,
                                            true
                                        );
                                         } catch (error) {
                                            logErrorToConsole(error);
                                       }
                                    }}
                                    style={{
                                        color: '#1010EB',
                                        fontSize: '16px',
                                        cursor: 'pointer',
                                    }}
                                >
                                    {`${vendorCaseErrorDetails.linkedSstRef}`}
                                </span>
                            )}
                    </Text>
                    {message2 && (
                        <Text
                            webHeight={webHeight ? webHeight : '130px'}
                            height={mbHeight ? mbHeight : '120px'}
                            paddingLeft={paddingLeft}
                        >
                            {message2}
                        </Text>
                    )}
                    <Div position={'block'}>
                        <Button
                            id={'reportUsage-common-warningModalOkBtn'}
                            show
                            width={'80px'}
                            height={'38px'}
                            // primary
                            variant ={ButtonStyles?.primary}
                            // borderRadius={'19px'}
                            // fontSize={'15px'}
                            // fontFamily={'AvenirNextWorld Demi'}
                            clicked={onClose}
                            margin={statusCode === '11909' ? '5% 0 0 0' : ''}
                        >
                            {t('noUsageToReport.okMsg')}
                        </Button>
                    </Div>
                </WarningModalDiv>
            </Popup>
        </>
    );
};

export default WarningModal;
